export const tearDownPubwise = () => {
  //every time we load a new script we need to try and get rid of them
  const w = window
  w.pbjs = w.pbjs || {}
  w.pbjs.que = w.pbjs.que || []
  w.pubwise = {
    enabled: true,
  };
}

const buildDntGuardedScripts = (srcs: (string | undefined)[]): string => {
  const valid = srcs.filter(Boolean) as string[];
  if (!valid.length) { return ''; }
  const loaders = valid
    .map((src) => { return `var s=document.createElement('script');s.async=true;s.src=${JSON.stringify(src)};document.head.appendChild(s);`; })
    .join('');
  return `<script>if(navigator.doNotTrack!=='1'){${loaders}}</script>`;
};

export const getScriptListString = (globalData: Record<string, any>) => {
  if (globalData && Object.values(globalData)[0]?.adScriptList) {
    const adList = Object.values(globalData)[0]?.adScriptList;
    return adList?.reduce(
      (_prev: any, next: { pubwisePreScript: any; pubwiseScript: any }) => {
        return buildDntGuardedScripts([next.pubwisePreScript, next.pubwiseScript]);
      },
      ''
    );
  }

  if (globalData?.commonData?.defaultAdData) {
    const adConfig: AdConfig = globalData.commonData?.defaultAdData;
    return adConfig?.adTag
      ? buildDntGuardedScripts([adConfig.adTag.pubwisePreScript, adConfig.adTag.pubwiseScript])
      : '';
  }

  return '';
};
